import { render, staticRenderFns } from "./sensitiveList.vue?vue&type=template&id=6319e564&scoped=true&"
import script from "./sensitiveList.vue?vue&type=script&lang=js&"
export * from "./sensitiveList.vue?vue&type=script&lang=js&"
import style0 from "./sensitiveList.vue?vue&type=style&index=0&id=6319e564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6319e564",
  null
  
)

export default component.exports